import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const spaceRolesSlice = createSlice({
  name: "getSpaceRoles",
  initialState: [],
  reducers: {
    setSpaceRoles: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

export const { setSpaceRoles } = spaceRolesSlice.actions;

export const getSpaceRoles = spaceRolesSlice.reducer;

export default spaceRolesSlice.reducer;
